import React, { useState } from 'react';
import { Button, CircularProgress, Typography, Box, Card, CardContent, Alert } from '@mui/material';
import { api } from '../api';

const WorkflowOwnershipFixer: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<{ fixed: number, total: number } | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleFixWorkflows = async () => {
    setLoading(true);
    setError(null);
    try {
      const fixResult = await api.fixWorkflowsOwnership();
      setResult(fixResult);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Workflow Ownership Fixer
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          If you're experiencing "Access denied to the specified workflow" errors, this tool can
          help assign your user ID to all workflows.
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {result && (
          <Alert severity="success" sx={{ mb: 2 }}>
            Fixed {result.fixed} of {result.total} workflows!
          </Alert>
        )}

        <Box sx={{ mt: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleFixWorkflows}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} /> : null}
          >
            {loading ? 'Fixing Workflows...' : 'Fix Workflow Ownership'}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default WorkflowOwnershipFixer; 